import { render, staticRenderFns } from "./RoomModal.vue?vue&type=template&id=19f6c4cb&"
import script from "./RoomModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./RoomModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports